<template>
    <div id="deposit-app-entry">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    async mounted () {
        try {
            const result = await this.$api.deposit.getUserCurrentStep()
            const data = result.data
            if (data.step === 'NONE') {
                if ( !(
                        this.$route.name === 'deposit-01' || 
                        this.$route.name === 'deposit-02'
                    )
                ) this.$router.replace({ name: 'deposit-01' }) // unintended access by user -> navigate to home
            } else if (data.step === 'WAIT_USER_CONFIRM') {
                this.$router.replace({ name: 'deposit-03' })
            } else if (data.step === 'WAIT_PROCESSED') {
                this.$router.replace({ name: 'deposit-04' })
            }
        } catch (error) {
            console.error(error)
        }
    }
}
</script>

<style lang="scss">
</style>
